import { dispatch } from 'fistore';
import { go } from 'fistore/routing/slice';

// Go to any state
export const frGo = (to, opts) => dispatch(go({ to, opts }));
